











import { computed, defineComponent, ref } from "@vue/composition-api";
import { CallOptions } from "@scrile/api-provider/dist/api/CallOptionsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseSwitch from "@/components/BaseSwitch";

export default defineComponent({
  name: "MoreMenuItemCallsToggle",
  components: { BaseSwitch, BaseIcon },
  setup() {
    const { authUser } = useAuthUser();
    const callOptions = ref<CallOptions | null>(null);

    const enabled = computed(() => !!callOptions.value?.enabled);

    const getCallOptions = async () => {
      if (!authUser.value) return;

      const response = await providers.CallOptionsProvider.find({ userIds: [authUser.value.id] });
      callOptions.value = response.find(i => i.userId === authUser.value?.id) ?? null;
    };

    const toggleCallOptions = async () => {
      if (!authUser.value) return;
      callOptions.value = await providers.CallOptionsProvider.update({
        data: { userId: authUser.value.id, enabled: !callOptions.value?.enabled },
      });
    };

    getCallOptions();

    return {
      enabled,
      toggleCallOptions,
    };
  },
});
